import React from 'react';

import ClearIcon from '@mui/icons-material/Clear';
import { gridRowSelectionStateSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-premium';

import { buttonWidths, DataGridExportButton, IconButton } from '@clatter/ui';
import styled from 'styled-components';

const StyledCustomToolbar = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;

  & > * {
    margin: 0 !important;
  }
`;

export const DataGridCustomToolbarRightSideActions = ({ exportFileName }) => {
  const apiRef = useGridApiContext();

  const selectionModel = useGridSelector(apiRef, gridRowSelectionStateSelector);

  const handleClearSelection = () => {
    const newSelectionModel = {
      type: 'include',
      ids: new Set(),
    };

    const propagatedModel = apiRef.current.getPropagatedRowSelectionModel(newSelectionModel);

    apiRef.current.setRowSelectionModel(propagatedModel);
  };

  return (
    <StyledCustomToolbar>
      {selectionModel?.ids?.size > 0 && (
        <IconButton tooltip="Clear Selection" width={buttonWidths.md} onClick={handleClearSelection}>
          <ClearIcon />
        </IconButton>
      )}

      <DataGridExportButton exportFileName={exportFileName} />
    </StyledCustomToolbar>
  );
};
